import { DateInput } from '@framework/form/inputs/DateInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import { stripHtmlForDisplay } from '../../../../ui/html/stripHtmlForDisplay.tsx';
import { Datatype, type FieldDatatype } from '../Datatype.ts';
import { $InputContainer } from './FieldDatatypeBooleanInput.style.tsx';
import { FieldDatatypeBooleanInput } from './FieldDatatypeBooleanInput.tsx';

export interface IFieldDatatypeValueInputProps {
  name: string;
  field: FieldDatatype;
  size?: SizeType;
  disabled?: boolean;
}

export function FieldDatatypeValueInput(props: IFieldDatatypeValueInputProps) {
  const { field, name, size, disabled } = props;

  if (field.type === Datatype.Array && field.itemsType === Datatype.Object) {
    return (
      <$InputContainer>
        <span>Non supportato</span>
      </$InputContainer>
    );
  }

  if (field.options && field.type !== Datatype.Array) {
    return (
      <SelectInput
        name={name}
        size={size || 'middle'}
        options={
          field.options?.map(o => ({
            ...o,
            label: stripHtmlForDisplay(o.label),
          })) ?? []
        }
        placeholder={'label' in field ? field.label : undefined}
        popupMatchSelectWidth={false}
        allowClear
        onChange={(value, option, onChange) => {
          if (disabled) return;
          onChange(value ?? null);
        }}
        disabled={disabled}
      />
    );
  }

  switch (field.type) {
    case Datatype.Array: {
      return (
        <SelectInput
          disabled={disabled}
          name={name}
          size={size ?? 'middle'}
          notFoundContent={!field.options ? null : undefined}
          style={{ minWidth: '180px' }}
          placeholder={
            field.options ? 'Seleziona...' : 'Scrivi e premi invio...'
          }
          mode={field.options ? 'multiple' : 'tags'}
          popupMatchSelectWidth={false}
          options={
            field.options?.map(o => ({
              ...o,
              label: stripHtmlForDisplay(o.label),
            })) ?? []
          }
          allowClear
          onChange={(value, option, onChange) => {
            onChange(value ?? null);
          }}
        />
      );
    }

    case Datatype.String:
      return (
        <TextInput
          name={name}
          size={size ?? 'middle'}
          placeholder={field.label}
          disabled={disabled}
        />
      );
    case Datatype.Number:
      return (
        <NumberInput
          name={name}
          size={size ?? 'middle'}
          placeholder={field.label}
          disabled={disabled}
        />
      );
    case Datatype.Boolean:
      return <FieldDatatypeBooleanInput name={name} disabled={disabled} />;
    case Datatype.Date:
      return (
        <DateInput name={name} size={size ?? 'middle'} disabled={disabled} />
      );
    default:
      return (
        <$InputContainer>
          <span>Non supportato</span>
        </$InputContainer>
      );
  }
}
